module.exports = __webpack_public_path__ + "static/media/hakMedia-main.827db82c.png";